import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useLocation, useRoutes } from "react-router-dom";
import AppRoute, { PublicRoutes } from "./config/app-route.jsx";
import Logout from "./pages/user/Logout.tsx";
import { Provider } from "react-redux";
import { ReactNotifications } from "react-notifications-component";
// bootstrap
import "bootstrap";

// css
import "@fortawesome/fontawesome-free/css/all.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./index.css";
import "/node_modules/react-grid-layout/css/styles.css"
import "/node_modules/react-resizable/css/styles.css"
import "./scss/react.scss";
import "bootstrap-social/bootstrap-social.css";
import "./assets/css/talentohumano.css";
import "react-notifications-component/dist/theme.css";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useSelector } from "react-redux";
import { store, persistor } from "./store/index.ts";
import { PersistGate } from "redux-persist/integration/react";
import Loader from "./components/Loader.tsx";
import { filterRoutes } from "./auth/filterRoutes.ts";

const container = document.getElementById("root");
const root = createRoot(container);
function App() {
  const location = useLocation();
  const { token, user } = useSelector((state) => state.auth);

  let element = token ? filterRoutes(AppRoute, user) : PublicRoutes;

  const routes = useRoutes(element);

  // Always available, even if role-filtering stripped the route or toasts cover the UI.
  if (location.pathname === "/logout") {
    return <Logout />;
  }

  return <React.Fragment>{routes}</React.Fragment>;
}

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={<Loader isLoading={true} />} persistor={persistor}>
        <App />
        <ReactNotifications />
      </PersistGate>
    </Provider>
  </BrowserRouter>
);
